import { apiFetch } from "../../lib/api";

export interface ChatGenerateParams {
  tab: string;
  wine: string;
  lang: string;
  maison?: string;
  pdfTxt?: string;
  imgB64?: string | null;
}

export interface ChatGenerateResult {
  text: string;
  prompt: string;
}

export interface HistoryEntry {
  id: number;
  wine: string;
  wineType: string | null;
  tab: string;
  tabId: string;
  lang: string;
  text: string;
  hasNote: boolean;
  time: string;
}

export async function generateChatContent(params: ChatGenerateParams): Promise<ChatGenerateResult> {
  const response = await apiFetch(
    "/generation/content",
    {
      method: "POST",
      body: JSON.stringify(params),
    },
    { auth: false }
  );

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Erreur de generation." }));
    throw new Error(error.error || "Erreur de generation.");
  }

  return response.json();
}

export async function parseChatCsv(raw: string): Promise<any[]> {
  const response = await apiFetch(
    "/generation/parse-csv",
    {
      method: "POST",
      body: JSON.stringify({ raw }),
    },
    { auth: false }
  );

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Erreur d'analyse CSV." }));
    throw new Error(error.error || "Erreur d'analyse CSV.");
  }

  const parsed = await response.json();
  return Array.isArray(parsed) ? parsed : [];
}

export async function fetchChatHistory(): Promise<HistoryEntry[]> {
  const response = await apiFetch("/history", {}, { auth: false });

  if (!response.ok) {
    throw new Error("Erreur lors du chargement de l'historique.");
  }

  const history = await response.json();
  return Array.isArray(history) ? history : [];
}

export async function addChatHistoryEntry(entry: HistoryEntry): Promise<HistoryEntry[]> {
  const response = await apiFetch(
    "/history",
    {
      method: "POST",
      body: JSON.stringify(entry),
    },
    { auth: false }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de l'ajout a l'historique.");
  }

  const history = await response.json();
  return Array.isArray(history) ? history : [];
}

export async function clearChatHistory(): Promise<void> {
  const response = await apiFetch("/history", { method: "DELETE" }, { auth: false });

  if (!response.ok && response.status !== 204) {
    throw new Error("Erreur lors de la suppression de l'historique.");
  }
}